/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import ReservationEvent from '../../event/ReservationEvent'
import { ReservationState } from '../state/ReservationState'
import { List } from 'immutable'
import CheckInEvent from '../../event/CheckInEvent'

class ReservationsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List.of(new ReservationState())
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationEvent.fetchByDate:
        return List(payload.reservations.map(r => new ReservationState(r)))

      case ReservationEvent.fetchAll:
        return List(payload.reservations.map(r => new ReservationState(r)))

      case ReservationEvent.onSearch:
        return List(payload.reservations.map(r => new ReservationState(r)))

      case ReservationEvent.onReceptionistSearch:
        return List(payload.reservations.map(r => new ReservationState(r)))

      // TODO チェックインイベントはここじゃない
      case CheckInEvent.fetchAll:
        return List(payload.reservations.map(r => new ReservationState(r)))

      default:
        return state
    }
  }
}

export default new ReservationsStore()
